module.exports = __webpack_public_path__ + "img/sapphireAndRubin@2x.445277e.webp";